import {AnimationBaseController, Inject} from "@denishussar/html5-game-engine";
import {IAnimationControllerConfiguration} from "@denishussar/html5-game-engine";
import {GameModel} from "../../Models/GameModel";


export class PreloaderBackgroundController extends AnimationBaseController {
    $model: GameModel;

    public constructor(@Inject private _options) {
        super("PreloaderBackgroundController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {};
    }

    protected onInitialize(): void {
    }

    protected onResize(width: number, height: number, scale: number): void {
        let sizeW = width/scale;
        let sizeH = height/scale;
        this.display.scale.set(sizeW/640, sizeH/480);
    }
}